import * as _ from "lodash";

import type { Light } from "@/models";

export const types = {
    SET_SETTINGS: "map/global/set-settings",
    UPDATE_SETTINGS: "map/global/update-settings",
    SAVE_SETTINGS: "map/global/save-settings",
    SET_HIGHLIGHT: "map/general/set-highlight",
    HIGHLIGHT_MAP: "map/general/highlight-map",
    DESELECT_ALL_LIGHTS: "map/general/deselect-all-lights",
    DESELECT_LIGHTS: "map/general/deselect-lights",
    SELECT_LIGHTS: "map/general/select-lights",
    DELETE_LIGHTS: "map/general/delete-lights",
    LOAD_REQUIREMENTS: "map/general/load-requirements",
    UPDATE_LIGHT_TYPES: "map/general/update-light-types",
    TOGGLE_SETTINGS_VISIBILITY: "map/general/toggle-visibility",
    UPDATE_MAP: "map/general/update-map",
    CHANGE_MODE: "map/general/change-mode",
    PERSIST_MODE_LIGHTS: "map/general/persist_mode_lights",
    SAVE_CHANGES: "map/general/save-changes",
    SET_SYNCING_STATUS: "map/general/set-syncing-status",
    SET_SYNCING_ERROR_MESSAGE: "map/general/set-syncing-error-message",
    CONFIGURE_ARRAY_OF_LIGHTS: "map/general/configure-array-of-lights",
    CLEAR_ARRAY_OF_LIGHTS: "map/general/clear-array-of-lights",
    TOGGLE_PASTE_MODE: "map/mode/toggle-paste-mode",
    SET_PASTE_MODE: "map/general/set-paste-mode",
    SET_CLIPBOARD: "map/general/set-clipboard",
    PASTE: "map/general/paste",
    COPY: "map/general/copy",
    CHECK_FLOORSPACE_CATALOGS: "map/general/check-floorspace-catalogs",
    RUN_DUPLICATES: "map/general/run-duplicates",
    SET_FLOORSPACE_CATALOGS: "map/general/set-floorspace-catalogs",
    SELECT_BLE: "map/general/select-ble",
    SET_FILTERED_FLAGS: "map/general/set-filtered-flags",
    SELECT_MATCHES: "map/general/select-matches",
    SET_LIGHT_SELECTION: "map/general/set-light-selection",
    SET_SEARCHED_LIGHTS: "map/general/set-searched-lights",
    SELECT_TOOL: "map/general/select-tool",
    SET_SELECTED_TOOL: "map/general/set-selected-tool",
    PERSIST_GROUP: "map/general/persist-group",
    SET_PENDING_GROUP_GEOMETRY: "map/general/set-pending-group-geometry",
    SET_EDITING_GROUP_GEOMETRY: "map/general/set-editing-group-geometry",
    SET_HOVERED_GROUP_GEOMETRY: "map/general/set-hovered-group-geometry",
    SET_LIGHT_GROUPS: "map/general/set-light-groups",
    ADD_LIGHT_GROUP: "map/general/add-light-group",
    SET_DEFAULT_LIGHT_GROUPS: "map/general/set-default-light-groups",
    SET_LIGHT_GROUP_SETTINGS: "map/general/set-light-group-settings",
    PUT_LIGHT_GROUP_SETTINGS: "map/general/put-light-group-settings",
    SET_EDITING_LIGHT_GROUP_SETTINGS:
        "map/general/set-editing-light-group-settings",
    UPDATE_EDITING_LIGHT_GROUP_SETTINGS:
        "map/general/update-editing-light-group-settings",
    SAVE_AND_PUBLISH_LIGHT_GROUP_SETTINGS:
        "map/general/save-and-publish-light-group-settings",
    SAVE_LIGHT_GROUP_SETTINGS: "map/general/save-light-group-settings",
    PUBLISH_ALL_LIGHT_GROUP_SETTINGS:
        "map/general/publish-all-light-group-settings",
    SET_LIGHT_GROUP_SETTINGS_PUBLISH_ALL_CONFIRMING:
        "map/general/set-light-group-settings-publish-all-confirming",
    SET_PENDING_LIGHT_GROUP_SETTINGS:
        "map/general/set-pending-light-group-settings",
    CLEAR_PENDING_LIGHT_GROUP_SETTINGS:
        "map/general/clear-pending-light-group-settings",
    SET_LIGHT_GROUP_SETTINGS_STATUS:
        "map/general/set-light-group-settings-status",
    SET_LIGHT_GROUP_SETTINGS_PROGRESS:
        "map/general/set-light-group-settings-progress",
    SET_SITE: "map/general/set-site",
    SET_FLOORSPACE_FILE_URL: "map/general/set-floorspace-file-url",
    START_DIM_TEST: "map/general/start-dim-test",
    SET_DIM_TEST_STATUS: "map/general/set-dim-tests-status",
    DELETE_MARKERS: "map/general/delete-markers",
    SELECT_MARKER: "map/general/select-marker",
    SELECT_MARKERS: "map/general/select-markers",
    DESELECT_ALL_MARKERS: "map/general/deselect-all-markers",
    UNCATALOG_LIGHTS: "map/general/uncatalog-lights",
    SET_UNCATALOG_CONFIRMING: "map/general/set-uncatalog-confirming",
    SET_FLOOR_SPACE_CATALOG_MAP: "map/general/set-floor-space-catalog-map",
};

export default {
    saveSettings: (settings) => ({
        type: types.SAVE_SETTINGS,
        payload: settings,
    }),
    setSettings: (settings) => ({
        type: types.SET_SETTINGS,
        payload: settings,
    }),
    updateSettings: (settings) => ({
        type: types.UPDATE_SETTINGS,
        payload: settings,
    }),
    highlightMap: ({
        column,
        row,
    }: { column?: unknown; row?: unknown } = {}) => ({
        type: types.HIGHLIGHT_MAP,
        payload: {
            column,
            row,
        },
    }),
    setHighlight: (highlight) => ({
        type: types.SET_HIGHLIGHT,
        payload: highlight,
    }),
    setSelectedTool: (tool) => ({
        type: types.SET_SELECTED_TOOL,
        payload: tool,
    }),
    selectTool: (tool) => ({
        type: types.SELECT_TOOL,
        payload: tool,
    }),
    setLightSelection: (enable) => ({
        type: types.SET_LIGHT_SELECTION,
        payload: enable,
    }),
    setFilteredFlags: (flags) => ({
        type: types.SET_FILTERED_FLAGS,
        payload: flags,
    }),
    setSearchedLights: (searchedLights) => ({
        type: types.SET_SEARCHED_LIGHTS,
        payload: searchedLights,
    }),
    selectBLE: (ble) => ({
        type: types.SELECT_BLE,
        payload: ble,
    }),
    selectMatches: (
        filteredItems,
        filterType = "flags",
        filteredMarkers = [],
    ) => ({
        type: types.SELECT_MATCHES,
        payload: { filteredItems, filterType, filteredMarkers },
    }),
    setFloorspaceCatalogs: (catalog) => ({
        type: types.SET_FLOORSPACE_CATALOGS,
        payload: catalog,
    }),
    checkFloorspaceCatalogs: (vlc, uniqueId) => ({
        type: types.CHECK_FLOORSPACE_CATALOGS,
        payload: {
            vlc,
            uniqueId,
        },
    }),
    runDuplicates: (lights) => ({
        type: types.RUN_DUPLICATES,
        payload: lights,
    }),
    deselectAllLights: () => ({ type: types.DESELECT_ALL_LIGHTS }),
    deselectLights: (lights: Light[]) => {
        const lightsIds = lights.map((light) => light.uniqueId);
        return {
            type: types.DESELECT_LIGHTS,
            payload: { lightsIds },
        };
    },
    selectLights: (lights, selectionType = "single") => {
        const lightsIds = _.map(
            lights instanceof Array ? lights : [lights],
            (light) => light.uniqueId,
        );
        return {
            type: types.SELECT_LIGHTS,
            payload: {
                lightsIds,
                selectionType,
            },
        };
    },
    deleteLights: () => ({
        type: types.DELETE_LIGHTS,
    }),
    deleteMarkers: () => ({
        type: types.DELETE_MARKERS,
    }),
    copy: () => ({
        type: types.COPY,
    }),
    paste: (point) => ({
        type: types.PASTE,
        payload: point,
    }),
    togglePasteMode: () => ({
        type: types.TOGGLE_PASTE_MODE,
    }),
    setClipboard: (lights) => ({
        type: types.SET_CLIPBOARD,
        payload: lights,
    }),
    setPasteMode: (activated, selectedLights) => ({
        type: types.SET_PASTE_MODE,
        payload: {
            activated,
            selectedLights,
        },
    }),
    persistModeLights: () => ({
        type: types.PERSIST_MODE_LIGHTS,
    }),
    loadRequirements: () => ({
        type: types.LOAD_REQUIREMENTS,
    }),
    saveChanges: () => ({
        type: types.SAVE_CHANGES,
    }),
    setSyncingStatus: (status) => ({
        type: types.SET_SYNCING_STATUS,
        payload: status,
    }),
    setSyncingErrorMessage: (message) => ({
        type: types.SET_SYNCING_ERROR_MESSAGE,
        payload: message,
    }),
    updateMap: ({ zoom, center }) => ({
        type: types.UPDATE_MAP,
        payload: { zoom, center },
    }),
    updateLightTypes: (lightTypes) => ({
        type: types.UPDATE_LIGHT_TYPES,
        payload: lightTypes,
    }),
    toggleSettingsVisibility: () => ({
        type: types.TOGGLE_SETTINGS_VISIBILITY,
    }),
    changeMode: (name, props = {}) => ({
        type: types.CHANGE_MODE,
        payload: { name, props },
    }),
    configureArrayOfLights: (configuration) => ({
        type: types.CONFIGURE_ARRAY_OF_LIGHTS,
        payload: configuration,
    }),
    clearArrayOfLights: () => ({
        type: types.CLEAR_ARRAY_OF_LIGHTS,
    }),
    persistGroup: () => ({
        type: types.PERSIST_GROUP,
    }),
    setHoveredGroupGeometry: (geometryId) => ({
        type: types.SET_HOVERED_GROUP_GEOMETRY,
        payload: geometryId,
    }),
    setPendingGroupGeometry: (value) => ({
        type: types.SET_PENDING_GROUP_GEOMETRY,
        payload: value,
    }),
    setEditingGroupGeometry: (geometryId) => ({
        type: types.SET_EDITING_GROUP_GEOMETRY,
        payload: geometryId,
    }),
    setLightGroups: (groups) => ({
        type: types.SET_LIGHT_GROUPS,
        payload: groups,
    }),
    addLightGroup: (group) => ({
        type: types.ADD_LIGHT_GROUP,
        payload: group,
    }),
    setDefaultLightGroups: (groups) => ({
        type: types.SET_DEFAULT_LIGHT_GROUPS,
        payload: groups,
    }),
    setLightGroupSettings: (settings) => ({
        type: types.SET_LIGHT_GROUP_SETTINGS,
        payload: settings,
    }),
    putLightGroupSettings: (settings) => ({
        type: types.PUT_LIGHT_GROUP_SETTINGS,
        payload: settings,
    }),
    setEditingLightGroupSettings: (settings) => ({
        type: types.SET_EDITING_LIGHT_GROUP_SETTINGS,
        payload: settings,
    }),
    updateEditingLightGroupSettings: (settings) => ({
        type: types.UPDATE_EDITING_LIGHT_GROUP_SETTINGS,
        payload: settings,
    }),
    saveAndPublishLightGroupSettings: () => ({
        type: types.SAVE_AND_PUBLISH_LIGHT_GROUP_SETTINGS,
    }),
    saveLightGroupSettings: () => ({
        type: types.SAVE_LIGHT_GROUP_SETTINGS,
    }),
    publishAllLightGroupSettings: () => ({
        type: types.PUBLISH_ALL_LIGHT_GROUP_SETTINGS,
    }),
    setLightGroupSettingsPublishAllConfirming: (confirming) => ({
        type: types.SET_LIGHT_GROUP_SETTINGS_PUBLISH_ALL_CONFIRMING,
        payload: confirming,
    }),
    setPendingLightGroupSettings: (settings) => ({
        type: types.SET_PENDING_LIGHT_GROUP_SETTINGS,
        payload: settings,
    }),
    clearPendingLightGroupSettings: () => ({
        type: types.CLEAR_PENDING_LIGHT_GROUP_SETTINGS,
    }),
    setLightGroupSettingsStatus: (status) => ({
        type: types.SET_LIGHT_GROUP_SETTINGS_STATUS,
        payload: status,
    }),
    setLightGroupSettingsProgress: (progress) => ({
        type: types.SET_LIGHT_GROUP_SETTINGS_PROGRESS,
        payload: progress,
    }),
    setSite: (site) => ({
        type: types.SET_SITE,
        payload: site,
    }),
    setFloorspaceFileUrl: (url) => ({
        type: types.SET_FLOORSPACE_FILE_URL,
        payload: url,
    }),
    startDimTest: (payload) => ({
        type: types.START_DIM_TEST,
        payload,
    }),
    setDimTestStatus: (payload) => ({
        type: types.SET_DIM_TEST_STATUS,
        payload,
    }),
    selectMarker: (marker) => ({
        type: types.SELECT_MARKER,
        payload: { markerId: marker.uniqueId },
    }),
    selectMarkers: (markerIds) => ({
        type: types.SELECT_MARKERS,
        payload: markerIds,
    }),
    deselectAllMarkers: () => ({ type: types.DESELECT_ALL_MARKERS }),
    uncatalogLights: () => ({
        type: types.UNCATALOG_LIGHTS,
    }),
    setUncatalogConfirming: (confirming) => ({
        type: types.SET_UNCATALOG_CONFIRMING,
        payload: confirming,
    }),
    setFloorSpaceCatalogMap: (catalogMap) => ({
        type: types.SET_FLOOR_SPACE_CATALOG_MAP,
        payload: catalogMap,
    }),
};
